import { z } from 'zod';
import { seasonFieldSchema } from '../season-field/schemas.ts';

export const methodologySeasonFieldSchema = seasonFieldSchema.extend({
  methodology_id: z.string().nullable()
});

export const methodologySeasonFieldsPageSchema = z.object({
  content: z.array(methodologySeasonFieldSchema),
  pageable: z.object({ size: z.number(), next_key: z.string().nullable() })
});
